import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";

/** @jsx $jsx */
import { $jsx } from 'framework7';
import $ from 'dom7';
import moment from 'moment';
import Base from '../js/base';
export default (function (props, ctx) {
  var lastMonth = moment().subtract(1, 'months').format('Y-MM');
  var lastMonthText = moment().subtract(1, 'months').format('M-Y'); // ctx.$on('page:init',function(){
  // });

  var rated = function rated(id_emp) {
    return $('.review-emp-table').find("tr[data-id_emp=\"".concat(id_emp, "\"] .review-button")).html('Đã đánh giá');
  };

  var checkRated = function checkRated(rated_rows) {
    if (rated_rows.length === 0) return;
    rated_rows.forEach(function (row) {
      return rated(row.id_emp);
    });
  };

  var working_rows = [];

  _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var rs;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return Base.api('Review', 'get', {});

          case 2:
            rs = _context.sent;

            if (!(rs.status === 'error')) {
              _context.next = 7;
              break;
            }

            //Không phải là người đánh giá
            ctx.$('.is-not-reviewer').removeClass('display-none');
            ctx.$('.is-reviewer').addClass('display-none');
            return _context.abrupt("return");

          case 7:
            ctx.$('.is-reviewer').removeClass('display-none');
            ctx.$('.is-not-reviewer').addClass('display-none');
            working_rows = rs.working_rows;
            ctx.$update(function () {
              checkRated(rs.rated_rows);
            });

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }))();

  Base.app.off('afterRated');
  Base.app.on('afterRated', function (data) {
    return rated(data.id_emp);
  });
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
<div class="page" data-name="cross-review">
  <div class="page-content">

    <div class="is-not-reviewer display-none">
      <div class="block">Bạn không phải là người đánh giá</div>
    </div>

    <div class="is-reviewer display-none">
      <div class="block">Những người sau đây cần bạn đánh giá trong tháng ${lastMonthText}:</div>
      <div class="data-table review-emp-table no-margin">
        <table>
          <thead>
            <tr>
              <th class="label-cell">Tên</th>
              <th class="numeric-cell">Số buổi</th>
              <th class="numeric-cell"></th>
            </tr>
          </thead>
          <tbody>
            ${working_rows.map(row=>$h`
              <tr data-id_emp="${row.id}">
                <td class="label-cell">${row.name}</td>
                <td class="numeric-cell">${row.count}</td>
                <td class="numeric-cell review-button"><a href="/cross-review-popup/${row.id}/${row.name}/${lastMonth}">Đánh giá</a></td>
              </tr>
            `)}
          </tbody>
        </table>
      </div>
    </div>

  </div>
</div>
`
    }
    ;
});